<template>
	<div>
		<div class="container">
			<h1>{{ $t('projectsPage.title') }}</h1>
			<ProjectsFilters v-model="filteredProjects" />
		</div>

		<div class="projects-grid">
			<ProjectPreview
				v-for="project in filteredProjects"
				:key="project.slug"
				:project="project"
			/>
		</div>
	</div>
</template>

<script>
import ProjectsFilters from '@/components/ProjectsFilters'
import ProjectPreview from '@/components/ProjectPreview'

export default {
	components: {
		ProjectsFilters,
		ProjectPreview,
	},

	data() {
		return {
			filteredProjects: [],
		}
	},
}
</script>

<style lang="scss" scoped>
// @import '@/sass/_variables';
</style>
